import React from "react";
import { Stack } from "@mui/material";
import { useTranslation } from "gatsby-plugin-react-i18next";

import NavbarLink from "./NavbarLink";
import { navbar_links } from "../../consts/Navbar/links";
import ServicesMenu from "../ServicesMenu";

export default function DesktopNavbarLinks() {
  const { t } = useTranslation();

  return (
    <Stack
      gap="12px"
      direction="row"
      alignItems="center"
      justifyContent="center"
    >
      {navbar_links.map((link) => {
        if (link.text === "Servicios") {
          return <ServicesMenu label={t(`${link.i18n}`)} key={link.text} to={link.to} />
        }
        return <NavbarLink label={t(`${link.i18n}`)} key={link.text} to={link.to} />
      })}
    </Stack>
  );
}
